<app-warnings-history-table [siteId]="siteId" [customerId]="customerId" [currentSite]="siteInfo"></app-warnings-history-table>
